import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './stores/index';
import './styles/main.scss';

// Only production builds report — keeps local dev noise out of the free-tier quota.
Sentry.init({
  dsn: 'https://14a3144429aa6f8a83c648021f14c07f@o4510760596471808.ingest.us.sentry.io/4512363286495232',
  enabled: process.env.NODE_ENV === 'production',
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  </Provider>
);
